
<app-header></app-header>
<app-club-header></app-club-header>
<app-right-side></app-right-side>
<div *ngIf="isLoaderVisible" class="preloader js-preloader">
    <img src="../../../assets/img/loader.webp">
</div>
<div class="container">
    <div class="row">
        <div class="col col-xl-9 order-xl-2 col-lg-9 order-lg-2 col-md-12 order-md-1 col-sm-12 col-12">
            <div class="ui-block">
                <div class="ui-block-title">
                    <h6 class="title">Football Leagues</h6>
                </div>
                <div class="ui-block-content">
                    <form class="content" [formGroup]="leagueForm" (ngSubmit)="addLeague()">
                        <div class="row">
                            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label">Name <span style="color: red;"> *</span></label>
                                    <input type="text" formControlName="leagueName" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.leagueName.errors }" />
                                    <div *ngIf="submitted && f.leagueName.errors" class="invalid-feedback">
                                        <div *ngIf="f.leagueName.errors.required">Title is required *</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label">Description <span style="color: red;"> *</span></label>
                                    <textarea class="form-control" name="leagueDescription"
                                        formControlName="leagueDescription" placeholder="Description..."
                                        [ngClass]="{ 'is-invalid': submitted && f.leagueDescription.errors }"></textarea>
                                    <div *ngIf="submitted && f.leagueDescription.errors" class="invalid-feedback">
                                        <div *ngIf="f.leagueDescription.errors.required">Description is required *</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label">Logo <span style="color: red;"> *</span></label>
                                    <input type="file" formControlName="leagueLogo" accept="image/*"
                                        class="form-control" (change)="onFileSelect($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.leagueLogo.errors }" />
                                    <div *ngIf=" submitted && f.leagueLogo.errors " class="invalid-feedback ">
                                        <div *ngIf="f.leagueLogo.errors.required ">Logo is required *</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <button class="btn btn-primary btn-lg full-width">
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div
            class="col col-xl-3 order-xl-1 col-lg-3 order-lg-1 col-md-12 order-md-2 col-sm-12 col-12 responsive-display-none ">
            <div class="ui-block ">
                <div class="your-profile">
                    <div id="accordion" role="tablist " aria-multiselectable="true ">
                        <div class="card">
                            <div id="collapseOne " class="collapse show " role="tabpanel "
                                aria-labelledby="headingOne ">
                                <ul class="your-profile-menu ">
                                    <li class="active ">
                                        <a routerLink="/club-dashboard" [queryParams]="{ 'id': clubData.id} "
                                            routerLinkActive="active "> Add News/Blogs</a>
                                    </li>
                                    <li>
                                        <a routerLink="/club-dashboard-media" [queryParams]="{ 'id': clubData.id} "
                                            routerLinkActive="active "> Add Photos/Videos</a>
                                    </li>
                                    <li>
                                        <a routerLink="/club-dashboard-matches" [queryParams]="{ 'id': clubData.id} "
                                            routerLinkActive="active ">Add Matches</a>
                                    </li>
                                    <li>
                                        <a routerLink="/club-dashboard-leagues" [queryParams]="{ 'id': clubData.id} "
                                            routerLinkActive="active "> Add Leagues</a>
                                    </li>
                                    <li>
                                        <a routerLink="/club-dashboard-player" [queryParams]="{ 'id': clubData.id} "
                                            routerLinkActive="active ">Add Player</a>
                                    </li>
                                    <li>
                                        <a routerLink="/club-dashboard-coach" [queryParams]="{ 'id': clubData.id} "
                                            routerLinkActive="active ">Add Coach</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>